import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import PcIframe from '../helper/pcIframe';
import { electronResCodeMap } from '../helper/codeMap';
import { log, bpitLog } from '../../utils';
var PcBridgeInit = function PcBridgeInit() {
  PcIframe.init();
};
var pcBridge = function pcBridge(method, param) {
  return new _Promise(function (resolve, reject) {
    return PcIframe.invokeAPI(method, param, function (_ref) {
      var data = _ref.data,
        code = _ref.code,
        message = _ref.message;
      var _code = _parseInt(code);
      var callbackStr = electronResCodeMap(_code);
      var callbackFun = param[callbackStr];
      log("SDK\u6267\u884C\u540E\u56DE\u8C03\uFF0C\u76F8\u5173\u53C2\u6570 ", {
        method: method,
        param: param,
        data: data,
        _code: _code,
        message: message,
        callbackFun: callbackFun
      });
      // 请求失败
      if (callbackStr === 'onFail') {
        bpitLog({
          method: method,
          errorcode: _code,
          message: message || _JSON$stringify(data) || 'SDK执行失败回调，相关参数'
        });
        if ('function' === typeof callbackFun) {
          console.log('wenai-code', code, _code);
          var callbackData = Object.prototype.toString.call(data) === "[object Object]" ? _Object$assign(_Object$assign({}, data), {
            code: code,
            message: message
          }) : {
            data: data,
            code: code,
            message: message
          };
          message ? callbackFun(callbackData) : callbackFun(data);
        }
        reject({
          _code: _code,
          message: message,
          data: data
        });
        return;
      }
      // 请求成功
      if ('function' === typeof callbackFun) {
        callbackFun(data || message);
      }
      resolve({
        _code: _code,
        message: message,
        data: data
      });
      //  if (_code === -2) {
      //   bpitLog({
      //     method,
      //     errorcode: _code,
      //     message: message || 'SDK执行失败回调，相关参数',
      //   });
      // }
      // const callbackFun = param[callbackStr];
      // log(`SDK执行后回调，相关参数 `, {
      //   method,
      //   param,
      //   data,
      //   _code,
      //   message,
      //   callbackFun
      // });
      // if ('function' === typeof callbackFun) {
      //   callbackFun(data || message);
      // }
      // resolve({ _code, message, data });
    });
  });
};

export { pcBridge, PcBridgeInit };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/bridge/pc.js
// module id = null
// module chunks = 